import "./product-image-slider.css";
import PropTypes from "prop-types";
import "swiper/css";
import "swiper/css/navigation";
import { Swiper, SwiperSlide } from "swiper/react";
import { Navigation, Thumbs } from "swiper/modules";
import { useState } from "react";
import styled, { keyframes } from "styled-components";

const shimmer = keyframes`
  0% {
    background-position: -200px 0;
  }
  100% {
    background-position: calc(200px + 100%) 0;
  }
`;

// Skeleton container with shimmer effect
const Skeleton = styled.div`
  position: absolute;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  background-color: #e0e0e0;
  background-image: linear-gradient(
    90deg,
    #e0e0e0 0px,
    #f5f5f5 40px,
    #e0e0e0 80px
  );
  background-size: 200px 100%;
  background-repeat: no-repeat;
  animation: ${shimmer} 1.2s infinite ease-in-out;
  border-radius: inherit;
  aspect-ratio:1;
  overflow:hidden;
`;

const ProductDetailsImgSlider = (props) => {
  const { image = [] } = props;
  const [activeThumb, setActiveThumb] = useState();
  const [loaded, setLoaded] = useState(false);
  

  return (
    <>
    <div className="pdp-container" style={{backgroundColor:'#fff ',maxWidth:'95vw',overflow:'hidden'}}>
      <Swiper
        style={{
          "--swiper-navigation-color": "#fff",
          "max-width": "100%",
          backgroundColor:'#fff',
          borderRadius:12,
         
        }}
        spaceBetween={10}
        navigation={true}
        modules={[Navigation, Thumbs]}
        grabCursor={true}
        thumbs={{ swiper: activeThumb }}
        className="product-images-slider"
      >
        {image?.length > 0 &&
          image?.map((item, index) => (
            <SwiperSlide key={index} style={{maxWidth:'101%'}}>
              <img src={item} style={{aspectRatio:1, overflow: 'hidden', position: 'relative',marginTop:'-100%'}} alt="product images" />
            </SwiperSlide>
          ))}
      </Swiper>

      <div>
      <Swiper
        style={{
          "--swiper-navigation-color": "#fff",
          "backgroundColor":'#fff',
          "max-width": "100%",
          "max-heigth": "160px",
          marginTop:'1rem'
        }}
        onSwiper={setActiveThumb}
        spaceBetween={10}
        slidesPerView={4}
        modules={[Navigation, Thumbs]}
        className="product-images-slider-thumbs"
      >
        {image?.length > 0 &&
          image?.map((item, index) => (
            <SwiperSlide key={index}
             style={{backgroundColor:'#fff'}}
            >
              {loaded ? null : <Skeleton />}
              <img
                src={item}
                style={{width:'100%',height:'100%',aspectRatio:1,borderRadius:11,marginRight:'1rem',backgroundColor:'#fff'}}
                alt="product-images"
                className="image-thumbnail"
                onLoad={() => setLoaded(true)}
                loaded={loaded}
              />
            </SwiperSlide>
          ))}
      </Swiper>
      </div>
      
     
    </div>
     <style>
        {`
        @media (max-width: 511px) {
          .pdp-container {
            max-width: 80vw;
          }
        }
        `}</style>
        </>
  );
};

ProductDetailsImgSlider.propTypes = {
  image: PropTypes.array.isRequired,
};

export default ProductDetailsImgSlider;
